import React from "react";
import ReactDOM from "react-dom/client";
import "./Styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// ✅ Import Toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    {/* Toast Container (should be outside App so it's globally available) */}
    <ToastContainer position="top-right" autoClose={3000} />
  </React.StrictMode>
);

// Register Service Worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register(
        "/service-worker.js"
      );
      console.log("✅ Service Worker registered:", registration);
    } catch (error) {
      console.error("❌ Service Worker registration failed:", error);
    }
  });
}

// // ✅ Register Service Workers ONLY in Production
if ("serviceWorker" in navigator) {
  if (process.env.NODE_ENV === "production") {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(() => console.log("✅ PWA Service Worker Registered"))
      .catch((err) =>
        console.error("❌ Service Worker Registration Failed:", err)
      );
  } else {
    console.log("⚠️ Service Worker Disabled in Development Mode");
  }
}

reportWebVitals();
